import { useState } from "react";
import styles from "./EnlargeModal.module.css";
import CloseIcon from "@mui/icons-material/Close";
import RottateLeftIcon from "@mui/icons-material/RotateLeft";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import axios from "axios";
import { toast } from "react-toastify";
import { url } from '../../../../../App'
import Cookies from "js-cookie";


const EnlargeDocModal = ({ closeModal, doc, docType, borrowerDetails, loanDetails, docName, coapplicantDetails }) => {
  console.log(doc, 'doc');
  console.log(docType);
  console.log(borrowerDetails);
  console.log(loanDetails);
  console.log(docName, 'document name');
  console.log(coapplicantDetails, 'coapp');

  const [zoomVal, setZoomVal] = useState(1);
  const [rotateVal, setRotateVal] = useState(0);
  const [saving, setSaving] = useState(false);
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');

  const zoomInHandler = () => {
    if (zoomVal > 1.6) return;
    setZoomVal(zoomVal + 0.2);
  };
  const zoomOutHandler = () => {
    if (zoomVal < 0.6) return;
    setZoomVal(zoomVal - 0.2);
  };

  const rotateLeftHadnler = () => {
    setRotateVal(rotateVal - 90);
  };
  const rotateRightHadnler = () => {
    setRotateVal(rotateVal + 90);
  };

  // const saveRotatedImage = async () => {
  //   console.log('save rotated')
  //   console.log(url);
  //   try {
  //     const img = new Image();

  //     img.src = `data:image/${docType};base64,${doc}`;

  //     img.onload = async () => {
  //       const canvas = document.createElement("canvas");
  //       const ctx = canvas.getContext("2d");

  //       const angle = rotateVal % 360;

  //       // Set canvas size based on rotation
  //       if (angle === 90 || angle === -90 || angle === 270 || angle === -270) {
  //         canvas.width = img.height;
  //         canvas.height = img.width;
  //       } else {
  //         canvas.width = img.width;
  //         canvas.height = img.height;
  //       }

  //       // Move canvas origin to center
  //       ctx.translate(canvas.width / 2, canvas.height / 2);

  //       // Rotate canvas
  //       ctx.rotate((angle * Math.PI) / 180);

  //       // Draw image
  //       ctx.drawImage(
  //         img,
  //         -img.width / 2,
  //         -img.height / 2
  //       );

  //       // Convert canvas to blob
  //       canvas.toBlob(
  //         async (blob) => {
  //           const formData = new FormData();

  //           formData.append( "file", blob, `rotated.${docType}`);

  //           formData.append("loanData", JSON.stringify(loanDetails));

  //           await axios.post(
  //             `${url}/loan/updateRotatedDoc`,
  //             formData,
  //             {
  //               headers: {
  //                 "Content-Type": "multipart/form-data",
  //               },
  //             }
  //           );

  //           toast.success("Image updated successfully");
  //         },
  //         `image/${docType}`,
  //         1
  //       );
  //     };
  //   } catch (err) {
  //     console.log(err);
  //     toast.error("Failed to save rotated image");
  //   }
  // };

  const saveRotatedImage = async () => {
    if (saving) return;
    setSaving(true);
    try {
      console.log('button clicked')
      const img = new Image();

      img.src = `data:image/${docType};base64,${doc}`;

      img.onload = async () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const angle = rotateVal % 360;

        if (
          angle === 90 ||
          angle === -90 ||
          angle === 270 ||
          angle === -270
        ) {
          canvas.width = img.height;
          canvas.height = img.width;
        } else {
          canvas.width = img.width;
          canvas.height = img.height;
        }

        ctx.translate(canvas.width / 2, canvas.height / 2);

        ctx.rotate((angle * Math.PI) / 180);

        ctx.drawImage(
          img,
          -img.width / 2,
          -img.height / 2
        );

        // BASE64
        const rotatedBase64 = canvas.toDataURL(`image/${docType}`);
        console.log(rotatedBase64);
        

        const updateImage = await axios.post(`${url}/loan/updateRotatedDoc`, {
          rotatedImage: rotatedBase64,
          loanDetails,
          token,
          email
        });

        if (updateImage.data.auth) {

          toast.success("Image updated successfully");
          closeModal();
          window.location.reload();

        } else {

          toast.error("Update Failed");
          setSaving(false);
          closeModal();
        }

      };
    } catch (err) {
      console.log(err);
      setSaving(false);
      toast.error("Failed");
    }
  };

  const saveRotatedImageCoapp = async () => {
    if (saving) return;
    setSaving(true);
    try {
      console.log('button clicked')
      const img = new Image();

      img.src = `data:image/${docType};base64,${doc}`;

      img.onload = async () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const angle = rotateVal % 360;

        if (
          angle === 90 ||
          angle === -90 ||
          angle === 270 ||
          angle === -270
        ) {
          canvas.width = img.height;
          canvas.height = img.width;
        } else {
          canvas.width = img.width;
          canvas.height = img.height;
        }

        ctx.translate(canvas.width / 2, canvas.height / 2);

        ctx.rotate((angle * Math.PI) / 180);

        ctx.drawImage(
          img,
          -img.width / 2,
          -img.height / 2
        );

        // BASE64
        const rotatedBase64 = canvas.toDataURL(`image/${docType}`);
        console.log(rotatedBase64);
        

        const updateImage = await axios.post(`${url}/coapplicant/updateRotatedDoc`, {
          rotatedImage: rotatedBase64,
          coapplicantDetails,
          token,
          email
        });

        if (updateImage.data.auth) {

          toast.success("Image updated successfully");
          closeModal();
          window.location.reload();

        } else {

          toast.error("Update Failed");
          setSaving(false);
          closeModal();
        }

      };
    } catch (err) {
      console.log(err);
      setSaving(false);
      toast.error("Failed");
    }
  };

  return (
    <>
      <div className={styles.enlargeDocumentsModal} style={{ zIndex: 999 }}>
        <div className={styles.enlargeDocumentsModaOverlay}>
          <div className={styles.enlargeDocumentsModalContent}>
            {loanDetails && docName === "self_photo" && (
              <button
                onClick={saveRotatedImage}
                disabled={saving}
                style={{
                  background: saving ? "#d3d3d3" : "green",
                  color: saving ? "#808080" : "white",
                  width: "70px",
                  height: "30px",
                  marginBottom: "50px",
                  position: "absolute",
                  left: "93%",
                  top: "10%",
                  borderRadius: "5px",
                  border: saving ? "1px solid #b0b0b0" : "none",
                  cursor: saving ? "not-allowed" : "pointer",
                  opacity: saving ? 0.8 : 1,
                }}
              >
                {saving ? "Saving..." : "Save"}
              </button>
            )}

            {coapplicantDetails && docName === "Self Photo" && (
              <button
                onClick={saveRotatedImageCoapp}
                disabled={saving}
                style={{
                  background: saving ? "#d3d3d3" : "green",
                  color: saving ? "#808080" : "white",
                  width: "70px",
                  height: "30px",
                  marginBottom: "50px",
                  position: "absolute",
                  left: "93%",
                  top: "10%",
                  borderRadius: "5px",
                  border: saving ? "1px solid #b0b0b0" : "none",
                  cursor: saving ? "not-allowed" : "pointer",
                  opacity: saving ? 0.8 : 1,
                }}
              >
                {saving ? "Saving..." : "Save"}
              </button>
            )}

            <CloseIcon
              className={styles.CloseIcon}
              onClick={closeModal}
              fontSize="large"
            />
            
            <button
              onClick={rotateLeftHadnler}
              className={`${styles.rotateLeft} ${styles.imgBtns}`}
            >
              <RottateLeftIcon fontSize="large" />
            </button>
            <button
              onClick={zoomInHandler}
              className={`${styles.zoomIn} ${styles.imgBtns}`}
            >
              <ZoomInIcon fontSize="large" />
            </button>
            <button
              onClick={zoomOutHandler}
              className={`${styles.zoomOut} ${styles.imgBtns}`}
            >
              <ZoomOutIcon fontSize="large" />
            </button>
            <button
              onClick={rotateRightHadnler}
              className={`${styles.rotateRight} ${styles.imgBtns}`}
            >
              <RotateRightIcon fontSize="large" />
            </button>
            <div className={styles.imgDiv}>
              <img
                draggable={false}
                src={`data:image/${docType};base64,${doc}`}
                alt="loading"
                // ref={imgRef}
                style={{
                  transform: `scale(${zoomVal}) rotate(${rotateVal}deg)`,
                  objectFit: "contain",
                  maxHeight: "100vh",
                  maxWidth: "100vw",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EnlargeDocModal;
